/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_DeletedInputs */

const en_aroma_deleted = /** @type {(inputs: Aroma_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aroma deleted`)
};

const es_aroma_deleted = /** @type {(inputs: Aroma_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aroma eliminado`)
};

/**
* | output |
* | --- |
* | "Aroma deleted" |
*
* @param {Aroma_DeletedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const aroma_deleted = /** @type {((inputs?: Aroma_DeletedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_DeletedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aroma_deleted(inputs)
	return es_aroma_deleted(inputs)
});